import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #3C2415 0%, #5D4037 100%);
  color: white;
  padding: 40px 0 20px;
  margin-top: auto;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, transparent 49%, rgba(255, 255, 255, 0.03) 50%, transparent 51%);
    background-size: 20px 20px;
    pointer-events: none;
  }
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const FooterTop = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

export const FooterSection = styled.div`
  h3 {
    color: #F5DEB3;
    margin-bottom: 20px;
    font-size: 1.2rem;
    font-weight: 600;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 30px;
      height: 2px;
      background: linear-gradient(90deg, #32CD32, #228B22);
      border-radius: 1px;
    }
  }
`;

export const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const FooterLink = styled.li`
  margin-bottom: 10px;
  
  a {
    color: #DEB887;
    text-decoration: none;
    transition: all 0.3s ease;
    position: relative;
    
    &:hover {
      color: #F5DEB3;
      padding-left: 5px;
    }
    
    &::before {
      content: '';
      position: absolute;
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 2px;
      background: #32CD32;
      transition: width 0.3s ease;
    }
    
    &:hover::before {
      width: 5px;
    }
  }
`;

export const ContactDetails = styled.div`
  p {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #DEB887;
    
    svg {
      width: 16px;
      height: 16px;
      color: #F5DEB3;
    }
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
`;

export const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(245, 222, 179, 0.1);
  border-radius: 50%;
  color: #DEB887;
  text-decoration: none;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(245, 222, 179, 0.2);
  
  &:hover {
    background: linear-gradient(135deg, #32CD32 0%, #228B22 100%);
    color: white;
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(50, 205, 50, 0.3);
    border-color: #32CD32;
  }
  
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 20px;
  text-align: center;
  
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const Copyright = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
`;

export const CompanyInfo = styled.div`
  p {
    margin-bottom: 15px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.9);
  }
`;
